const SHAPE_PATHS = {
  circle: <circle cx="12" cy="12" r="9" />,
  square: <rect x="3.5" y="3.5" width="17" height="17" rx="2" />,
  triangle: <polygon points="12,2.5 22,20.5 2,20.5" />,
  diamond: <polygon points="12,2 22,12 12,22 2,12" />,
  hexagon: <polygon points="12,2 21,7 21,17 12,22 3,17 3,7" />,
};
const SHAPE_COLORS = ["#ef4444", "#facc15", "#22c55e", "#ffffff", "#fb923c"];
const SHAPES = SHAPE_COLORS.flatMap((color) => Object.keys(SHAPE_PATHS).map((shape) => ({ shape, color })));

const Shape = ({ shape, color }) => (
  <svg viewBox="0 0 24 24" className="h-[60%] w-[60%] drop-shadow" fill={color} stroke="rgba(15,23,42,0.55)" strokeWidth="1.2">
    {SHAPE_PATHS[shape]}
  </svg>
);

const LETTERS = "ABCDEFGHIJKLMNOPQRSTUVWXY".split("");
const EMOJIS = ["🐶", "🐱", "🐭", "🐹", "🐰", "🦊", "🐻", "🐼", "🐨", "🐯", "🦁", "🐮", "🐷", "🐸", "🐵", "🐔", "🐧", "🐦", "🐤", "🦆", "🦉", "🐴", "🦄", "🐝", "🐞"];
const SYMBOLS = ["♠", "♥", "♦", "♣", "☀", "☂", "☃", "☎", "♪", "♫", "✈", "☯", "☮", "⚓", "⚡", "✿", "❄", "☘", "♞", "♛", "✂", "✎", "⌛", "☕", "⚽"];

const text = (list, cls) => (i) => <span className={cls}>{list[i - 1]}</span>;

export const CATEGORIES = {
  numbers: { id: "numbers", name: "Numbers", sample: "1 2 3", render: (i) => <span className="font-display font-black">{i}</span> },
  letters: { id: "letters", name: "Letters", sample: "A B C", render: text(LETTERS, "font-display font-black") },
  emojis: { id: "emojis", name: "Emojis", sample: "🐶 🐱 🐭", render: text(EMOJIS, "leading-none") },
  symbols: { id: "symbols", name: "Symbols", sample: "♠ ♥ ♦", render: text(SYMBOLS, "font-bold leading-none") },
  shapes: { id: "shapes", name: "Shapes", sample: "● ■ ▲", render: (i) => <Shape {...SHAPES[i - 1]} /> },
};
